/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { HistoryGroupHeader as RecordingActivityHeaderType } from 'client-code/recordings';

import '../RecordingActivityContent.scss';

export type RecordingActivityHeaderProps = {
    header: RecordingActivityHeaderType;
};

const RecordingActivityHeader = ({ header }: RecordingActivityHeaderProps) => {
    return (
        <div className="recording-activity-list-header" data-testid="recording-activity-list-item">
            <div className="recording-activity-list-row">
                <div className="recording-activity-row-cell status-icon"></div>
                <div className="recording-activity-row-cell recording-activity-list-header-text">
                    {header.name}
                </div>
            </div>
        </div>
    );
};

export default RecordingActivityHeader;
